// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cLuU36mc{align-items:center;border-bottom:1px solid var(--theme-border);display:flex;gap:calc(var(--space)*2);padding:calc(var(--space)*.75) calc(var(--space)*2);justify-content:flex-end}`, "",{"version":3,"sources":["webpack://./src/page-components/merge-dialog-controls/MergeDialogControls.module.scss"],"names":[],"mappings":"AAAA,UACE,kBAAA,CACA,2CAAA,CACA,YAAA,CACA,wBAAA,CACA,mDAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `cLuU36mc`
};
export default ___CSS_LOADER_EXPORT___;
